module.exports = __webpack_public_path__ + "dist/img/usbank-logo-v2.735bd56c.png";